import React from "react";

function NotFoundPage() {
  return (
    <div className="notes-list-empty">
      <p>
        <strong>404 Page Not Found</strong>
      </p>
      <p>Maaf, Halaman Tidak Ditemukan</p>
    </div>
  );
}

export default NotFoundPage;
